import { useQuery } from "react-query"
import { getTenantLastActivity } from "./tenantLastActivityApi"


export const useTenantLastActivityQuery = () => {
  return useQuery(['tenantLastActivity'], {
    queryFn: () => getTenantLastActivity()
  })
}